import { render, staticRenderFns } from "./InstitutionsPie.vue?vue&type=template&id=5136ffff&"
import script from "./InstitutionsPie.vue?vue&type=script&lang=js&"
export * from "./InstitutionsPie.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports